import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';
import { useQuery } from '@tanstack/react-query';

import { EligibleFeaturesModel } from '../models';

const ELIGIBLE_FEATURES_URL = `${MOKA_GOAUTH_SERVICE}/inventory/v1/feature-flag/eligible-features`;

async function fetchEligibleFeatures() {
  const resp = await axios.get(ELIGIBLE_FEATURES_URL);

  return resp.data;
}

function useEligibleFeatures() {
  const { data } = useQuery<EligibleFeaturesModel.Response>(['eligible-features'], fetchEligibleFeatures);

  return Array.isArray(data) ? data.map((feature) => feature.name) : [];
}

export { ELIGIBLE_FEATURES_URL, fetchEligibleFeatures, useEligibleFeatures };
